import RequestService from '../requestService';
import {client} from '../../client';
import {Tilgangskode} from '../../../models';

export default class TilgangskodeService extends RequestService<Tilgangskode, 'tilgangskoder'>
{
  validateTilgangskode = async (value : Tilgangskode) => client.post<boolean>(`${this.serviceName}/ValidateTilgangskode`,value);
}
